import { forwardRef } from "react";
import PropTypes from "prop-types";
import Dropdown from "react-bootstrap/Dropdown";

import Icon from "../icon/Icon";

export const IMPLEMENTATION_GUIDE_URL =
    "https://docs.google.com/document/d/1FFnIklzUg7fzCBZy0VmWwLooS7wAWMokMQoNf7ZgVh0/edit?tab=t.0";
export const QUICK_START_GUIDE_URL =
    "https://docs.google.com/document/d/1m4e2qyG7gJOINAauzzqa1ISaTvwGcs0Ztyg6X3d5fD0/edit?tab=t.0";

const ResourcesToggle = forwardRef(({ onClick }, ref) => (
    <button
        aria-label="Resources Button"
        className="a-action-button-dup"
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
        ref={ref}
        type="button"
    >
        <span className="nav-button-text">
            Resources
            <Icon className="nav-button-icon" fill="white" iconName="WRENCH" width={30} />
        </span>
    </button>
));

ResourcesToggle.displayName = "ResourcesToggle";

ResourcesToggle.propTypes = {
    onClick: PropTypes.func
};

ResourcesToggle.defaultProps = {
    onClick: () => {}
};

/**
 * Teacher header dropdown with Report Card guide links.
 * @name ResourcesLinks
 * @returns {JSX.Element}
 */
const ResourcesLinks = () => (
    <Dropdown align="end" className="resources-links-dropdown">
        <Dropdown.Toggle as={ResourcesToggle} id="resources-links-dropdown" />
        <Dropdown.Menu>
            <Dropdown.Item href={IMPLEMENTATION_GUIDE_URL} rel="noreferrer" target="_blank">
                <i className="bi bi-journal-text" aria-hidden="true" /> Implementation Guide
            </Dropdown.Item>
            <Dropdown.Item href={QUICK_START_GUIDE_URL} rel="noreferrer" target="_blank">
                <i className="bi bi-lightning-charge" aria-hidden="true" /> Quick Start Guide
            </Dropdown.Item>
        </Dropdown.Menu>
    </Dropdown>
);

export default ResourcesLinks;
